import { Table } from 'antd';
import React from 'react';

type Props = {
    students: any;
}

const AffiliatedStudentsTable: React.FC<Props> = ({ students }) => {

    const filteredStudents = students.filter((student: any) => !student.id);

    // Define columns for the table
    const columns = [
        {
            title: 'Nom',
            dataIndex: 'lastname',
            key: 'lastname',
        },
        {
            title: 'Prénom',
            dataIndex: 'firstname',
            key: 'firstname',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Statut',
            dataIndex: 'status',
            key: 'accepted',
            render: (accepted: boolean) => {
                return accepted ? 'Affilié' : 'Affiliation en cours';
            }
        }
    ];

    return (
        <Table dataSource={filteredStudents} columns={columns} />
    );
};

export default AffiliatedStudentsTable;
